import React from 'react'

// Common base font styling to match the legacy theme
const baseBadgeStyle: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#ffffff',
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  fontSize: '11px',
  borderRadius: '4px',
  lineHeight: 1,
  userSelect: 'none',
}

export const ProcessingServiceBadge = (
  { text, bgColor }: { text: string, bgColor?: string }
): JSX.Element => {
  const style: React.CSSProperties = {
    ...baseBadgeStyle,
    backgroundColor: bgColor || '#718096',
    fontWeight: 700,
    padding: '2px 6px',
    height: '14px',
    whiteSpace: 'nowrap',
  }

  return <span style={style}>{text}</span>
}
